import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { TcDirectorySurvivalProgram } from '../_types';
import { classnames } from 'tailwindcss-classnames';

const StaffComponent = ({ fields }: TcDirectorySurvivalProgram) => {
  if (!fields) {
    return <MissingDataSource />;
  }
  let adultandPediatricDir = null;
  let adultandPediatricCoord = null;

  if (fields?.adultDir?.value && fields?.pedDir?.value) {
    if (fields.adultDir.value === fields.pedDir.value) {
      // Both adult & ped directors exist
      adultandPediatricDir = // Same person for both director roles
        (
          <div>
            <span className={classnames('pr-1')}>Program Director:</span>
            {fields.adultDir.value}
          </div>
        );
    } else {
      adultandPediatricDir = // Different people for each director role
        (
          <div>
            <span className={classnames('pr-1')}>Adult Program Director:</span>
            {fields.adultDir.value}
            <span className={classnames('pr-1')}>Pediatric Program Director:</span>
            {fields.pedDir.value}
          </div>
        );
    }
  } else if (fields?.adultDir?.value) {
    adultandPediatricDir = // Only adult director exists
      (
        <div>
          <span className={classnames('pr-1')}>Program Director:</span>
          {fields.adultDir.value}
        </div>
      );
  } else if (fields?.pedDir?.value) {
    adultandPediatricDir = // Only ped director exists
      (
        <div>
          <span className={classnames('pr-1')}>Program Director:</span>
          {fields.pedDir.value}
        </div>
      );
  }

  if (fields?.adultDir?.value && fields?.pedDir?.value) {
    if (fields.adultDir.value === fields.pedDir.value) {
      // Both adult & ped Coordinators exist
      adultandPediatricCoord = // Same person for both Coordinator roles
        (
          <div>
            <span className={classnames('pr-1')}>Program Coordinator:</span>
            {fields.adultCoord.value}
          </div>
        );
    } else {
      adultandPediatricCoord = // Different people for each Coordinator role
        (
          <div>
            <span className={classnames('pr-1')}>Adult Program Coordinator:</span>
            {fields.adultCoord.value}
            <span className={classnames('pr-1')}>Pediatric Program Coordinator:</span>
            {fields.adultCoord.value}
          </div>
        );
    }
  } else if (fields?.adultDir?.value) {
    adultandPediatricCoord = // Only adult Coordinator exists
      (
        <div>
          <span className={classnames('pr-1')}>Program Coordinator:</span>
          {fields.adultCoord.value}
        </div>
      );
  } else if (fields?.pedDir?.value) {
    adultandPediatricCoord = // Only ped Coordinator exists
      (
        <div>
          <span className={classnames('pr-1')}>Program Coordinator:</span>
          {fields.pedCoord.value}
        </div>
      );
  }

  return (
    <>
      <div className={classnames('mb-6')}>
        {(fields?.adultDir?.value ||
          fields?.pedDir?.value ||
          fields?.adultCoord?.value ||
          fields?.pedCoord?.value) && (
          <h2 className={classnames('heading-md', 'my-4', 'max-w-prose', 'text-left')}>
            <span className={classnames('inline-block')}>Staff</span>
          </h2>
        )}

        {fields?.type?.fields?.Value?.value === 'Adult' && (
          <div>
            {fields?.adultDir?.value && (
              <div>
                <span className={classnames('pr-1')}>Program Director:</span>
                {fields.adultDir.value}
              </div>
            )}
            {fields?.adultCoord?.value && (
              <div>
                <span className={classnames('pr-1')}>Program Coordinator:</span>
                {fields.adultCoord.value}
              </div>
            )}
          </div>
        )}
        {fields?.type?.fields?.Value?.value === 'Pediatric' && (
          <div>
            {fields?.pedDir?.value && (
              <div>
                <span className={classnames('pr-1')}>Program Director:</span>
                {fields.pedDir.value}
              </div>
            )}
            {fields?.pedCoord?.value && (
              <div>
                <span className={classnames('pr-1')}>Program Coordinator:</span>
                {fields.pedCoord.value}
              </div>
            )}
          </div>
        )}
        {fields?.type?.fields?.Value?.value === 'Pediatric/Adult' && (
          <div>
            {adultandPediatricDir}
            {adultandPediatricCoord}
          </div>
        )}
      </div>
    </>
  );
};

export default StaffComponent;
